<template>
  <v-app>
    <v-container class="fill-height login" fluid>
      <v-row>
        <v-col class="d-flex justify-center align-center">
          <div>
            <h1>Registret</h1>
            <p class="caption">4.0</p>
          </div>
        </v-col>
        <v-col class="login-card">
          <login-deck />
        </v-col>
      </v-row>
      <v-row>
        <v-col>  
          <v-icon class="logo">$sl-BYN_Logo</v-icon>        
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import LoginDeck from '@/components/LoginDeck'
// @group Common
// LoggedOutLayout component
export default {
  name: 'LoggedOutLayout',
  components: {
    LoginDeck
  }
}
</script>

<style lang="scss" scoped>
// .theme--light.v-application {
//   background-image: url('../assets/images/front-hero.jpg') !important;
//   background-color: white !important;
//   background-repeat: no-repeat !important;
//   background-size: cover !important;
//   background-position: right top !important;
//   width: 100% !important;
//   max-width: 100% !important;
//   margin: 0px !important;
//   padding: 0px !important;
// }

h1 {
  font-size: 96px !important;
  line-height: 112px !important;
}
</style>